<template>
  <tr>
    <td class="text-xs-left">
      <v-checkbox
        v-model="props.selected"
        hide-details
      />
    </td>
    <td>
      {{ fullName }}
    </td>
    <td class="text-xs-left">
      {{ props.item.email }}
    </td>
  </tr>
</template>
<script>
export default {
  name: 'CustomerGroupCustomersDataTableRow',

  props: {
    props: {
      type: Object,
      required: true
    }
  },

  computed: {
    fullName () {
      return this.props.item.firstname + ' ' + this.props.item.lastname
    }
  }
}
</script>
